import consumer from './consumer';

if (window.ExportChannel === undefined) {
  window.ExportChannel = {};
}

window.ExportChannel.Subscribe = (exportId, connectedCallback, receivedCallback) => {
  const subscription = consumer.subscriptions.create({
      channel: 'ExportChannel',
      export_id: exportId,
    }, {
      connected: connectedCallback,
      received: (data) => {
        // Download
        const binary = atob(data['content']);
        const bytes = new Uint8Array(binary.length);
        for (let i = 0; i < binary.length; i++) bytes[i] = binary.charCodeAt(i);
        const blob = new Blob([bytes]);
        const downloadLink = document.createElement('a');
        downloadLink.href = window.URL.createObjectURL(blob);
        downloadLink.download = data['filename'];
        downloadLink.click();

        // Unsubscribe & disconnect
        subscription.unsubscribe();
        consumer.disconnect();

        receivedCallback();
      },
    }
  );
};
